class StackingCards {
  constructor(section) {
    this.section = section;
    this.content = section.querySelector('.stacking-cards__content');
    this.cards = Array.from(section.querySelectorAll('.stacking-cards__card'));
    this.cardsContainer = section.querySelector('.stacking-cards__cards');
    this.endTrigger = section.querySelector('.stacking-cards__end-trigger');
    this.scrollTriggers = [];
    this.initialized = false;

    this.init();
  }

  init() {
    // Only apply stacking on desktop
    if (window.innerWidth < 990) {
      return;
    }

    // Wait for GSAP and ScrollTrigger to load
    this.initWhenReady();
  }

  initWhenReady() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(() => this.initWhenReady(), 100);
      return;
    }

    this.setupStackingAnimation();
  }

  setupStackingAnimation() {
    if (this.initialized || this.cards.length === 0) return;
    this.initialized = true;

    gsap.registerPlugin(ScrollTrigger);

    const topOffset = 100; // Gap from top in pixels
    const stackOffset = 20; // Visible offset between stacked cards (pixels)

    // Get the last card
    const lastCard = this.cards[this.cards.length - 1];

    // Calculate the height of the last card
    const lastCardHeight = lastCard.clientHeight;

    // Pin the left content with the same top offset
    ScrollTrigger.create({
      trigger: this.cardsContainer,
      start: `top top+=${topOffset}px`,
      endTrigger: this.cardsContainer,
      end: `bottom top+=${lastCardHeight}px`,
      pin: this.content,
      pinSpacing: false,
      markers: false
    });

    // Polaroid rotation angles - alternating slight tilts
    const rotations = [-2, 1.5, -1, 2, -1.5, 1];

    // Animate each card using the working pattern
    this.cards.forEach((card, index) => {
      // Stack earlier: each card pins higher up based on its index
      const cardOffset = topOffset + (index * stackOffset);
      const isLastCard = card === lastCard;

      // Get rotation for this card (cycles through rotations array)
      const rotation = rotations[index % rotations.length];

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: card,
          start: `top top+=${cardOffset}px`,
          endTrigger: this.cardsContainer,
          end: `bottom top+=${lastCardHeight}px`,
          pin: true,
          pinSpacing: false,
          scrub: true,
          markers: false
        }
      });

      // Scale down and add rotation for polaroid pile effect
      tl.to(card, {
        scale: 0.92 + 0.015 * index,
        rotation: rotation,
        transformOrigin: 'center center'
      });

      this.scrollTriggers.push(tl.scrollTrigger);
    });

    // Refresh ScrollTrigger after setup
    ScrollTrigger.refresh();
  }

  destroy() {
    // Kill all ScrollTriggers
    this.scrollTriggers.forEach(trigger => {
      if (trigger) trigger.kill();
    });
    this.scrollTriggers = [];

    // Reset card styles
    this.cards.forEach(card => {
      gsap.set(card, { clearProps: 'all' });
    });

    this.initialized = false;
  }

  refresh() {
    if (this.initialized && typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  }
}

// Initialize all stacking card sections
function initStackingCards() {
  const sections = document.querySelectorAll('.stacking-cards');
  const instances = [];

  sections.forEach(section => {
    instances.push(new StackingCards(section));
  });

  // Refresh on window resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const isMobile = window.innerWidth < 990;

      // Destroy and reinit based on screen size
      instances.forEach(instance => {
        instance.destroy();
        if (!isMobile) {
          instance.init();
        }
      });
    }, 250);
  });

  // Clean up on page unload
  window.addEventListener('beforeunload', () => {
    instances.forEach(instance => instance.destroy());
  });

  return instances;
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStackingCards);
} else {
  initStackingCards();
}

// Re-initialize if Shopify theme editor reloads sections
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initStackingCards, 100);
  });
}
